import { ref as r, reactive as V, computed as $, onMounted as W, nextTick as C, onBeforeUnmount as j, createElementBlock as n, openBlock as l, normalizeClass as D, createElementVNode as d, createCommentVNode as x, normalizeStyle as G, Fragment as M, renderList as E, withDirectives as K, createVNode as F, vShow as U } from "vue";
import J from "../../molecules/quote/quote-simple/quote-simple.vue.js";
import { screenProp as X } from "../../utils/utilsScreen.js";
import { themeProp as Y } from "../../composables/useTheme.js";
/* empty css                 */
import Z from "../../_virtual/_plugin-vue_export-helper.js";
const ee = { class: "ds-quote-group__tabs-container" }, te = ["aria-selected", "tabindex", "aria-controls", "onClick"], oe = ["src", "alt", "loading"], se = { class: "ds-quote-group__tab-content-wrapper" }, ae = ["id"], re = {
  key: 0,
  class: "ds-quote-group__dots ds-margin-top-48"
}, T = 6e3, ne = 184, le = /* @__PURE__ */ Object.assign({
  name: "DsQuoteGroup"
}, {
  __name: "quote-group",
  props: {
    ...X,
    ...Y,
    quotes: { type: Array, required: !0 }
  },
  setup(k) {
    const u = k, a = r(0), p = r(!1), w = r(0), v = r(null), g = r(null), L = r(!1), c = V({
      elapsedTime: 0,
      remainingTime: T
    }), S = V({
      left: 0
    }), f = r(null), O = r([]);
    let h = null;
    const H = $(() => u.quotes.map((e) => e.logo)), P = (e) => {
      e.forEach((s) => {
        s.isIntersecting && s.intersectionRatio >= 0.5 ? _() : b();
      });
    }, R = () => {
      const e = O.value, s = e.map((o) => o.style.display);
      e.forEach((o) => {
        o.style.display = "block";
      }), C(() => {
        const o = e.map((I) => I.getBoundingClientRect().height), t = Math.max(...o);
        document.querySelector(".ds-quote-group__tab-content-wrapper").style.setProperty("height", `${t}px`, "important"), e.forEach((I, Q) => {
          I.style.display = s[Q];
        });
      });
    }, z = () => {
      w.value = 0, c.startTime = Date.now(), c.elapsedTime = 0, c.remainingTime = T;
    }, m = (e) => {
      if (e !== a.value) {
        if (e === 0 && a.value === u.quotes.length - 1) {
          const s = 1 / u.quotes.length;
          S.transition = s + "s !important";
        }
        if (a.value = e, S.left = ne * e + "px", B.value) {
          const s = f.value, o = s.querySelectorAll(".ds-quote-group__tab")[e];
          if (o && s) {
            const t = o.offsetLeft;
            s.scrollLeft = t;
          }
          b(), p.value = !1, _();
        }
        z();
      }
    }, B = $(() => f.value && f.value.scrollWidth > f.value.offsetWidth), A = (e, s = !0) => s ? (e + 1) % u.quotes.length : (e - 1 + u.quotes.length) % u.quotes.length, _ = () => {
      v.value && clearInterval(v.value), v.value = setInterval(() => {
        p.value || (c.elapsedTime += 100, c.remainingTime -= 100, w.value = c.elapsedTime / T * 100, c.elapsedTime >= T && (m(A(a.value)), z()));
      }, 100);
    }, b = () => {
      clearInterval(v.value), v.value = 0;
    }, q = () => {
      p.value = !0, b();
    }, y = () => {
      p.value = !1, _();
    }, N = (e) => {
      var s, o, t;
      if (["ArrowRight", "ArrowLeft"].includes(e.key)) {
        e.preventDefault();
        const i = e.key === "ArrowRight" ? A(a.value) : A(a.value, !1);
        m(i), (s = g.value[i]) == null || s.focus();
      } else if (e.key === "Home")
        e.preventDefault(), m(0), (o = g.value[0]) == null || o.focus();
      else if (e.key === "End") {
        e.preventDefault();
        const i = u.quotes.length - 1;
        m(i), (t = g.value[i]) == null || t.focus();
      }
    };
    return W(async () => {
      _(), await C(), h = new IntersectionObserver(P, {
        threshold: 0.5
      }), h.observe(document.querySelector(".ds-quote-group")), R(), await C(), L.value = !0;
    }), j(() => {
      b(), h && h.disconnect();
    }), (e, s) => (l(), n("div", {
      class: D(["ds-quote-group", [`ds-quote-group--${e.theme}`]]),
      onKeydown: N
    }, [
      d("div", ee, [
        d("div", {
          ref_key: "tabTitles",
          ref: f,
          role: "tablist",
          class: "ds-quote-group__tabs"
        }, [
          d("div", {
            class: "ds-quote-group__tab-background",
            style: G(S)
          }, null, 4),
          (l(!0), n(M, null, E(H.value, (o, t) => (l(), n("button", {
            key: t,
            ref_for: !0,
            ref_key: "tabs",
            ref: g,
            "aria-selected": a.value === t,
            tabindex: t === a.value ? 0 : -1,
            role: "tab",
            "aria-controls": `content-${t}`,
            class: "ds-quote-group__tab",
            onClick: (i) => m(t),
            onMouseenter: q,
            onMouseleave: y,
            onTouchstart: q,
            onTouchend: y
          }, [
            d("img", {
              class: "ds-quote-group__tab-logo",
              src: o.src,
              alt: o.alt,
              loading: o.lazy ? "lazy" : "eager"
            }, null, 8, oe),
            d("div", {
              class: D(["ds-quote-group__tab-progress", { active: a.value === t, inactive: a.value !== t }]),
              style: G({
                width: a.value === t ? w.value + "%" : "0%",
                transition: p.value ? "none" : "width 0.1s linear"
              })
            }, null, 6)
          ], 40, te))), 128))
        ], 512),
        d("div", se, [
          (l(!0), n(M, null, E(k.quotes, (o, t) => (l(), n("div", { key: t }, [
            K(d("div", {
              id: `content-${t}`,
              ref_for: !0,
              ref_key: "tabContents",
              ref: O,
              role: "tabpanels",
              tabindex: "0",
              class: "ds-quote-group__tab-content",
              onMouseenter: q,
              onMouseleave: y,
              onTouchstart: q,
              onTouchend: y
            }, [
              F(J, {
                text: o.text,
                author: o.author,
                "extra-info": o.extraInfo,
                theme: e.theme,
                screen: e.screen,
                animate: L.value,
                class: "ds-quote-group__tab-quote"
              }, null, 8, ["text", "author", "extra-info", "theme", "screen", "animate"])
            ], 40, ae), [
              [U, a.value === t]
            ])
          ]))), 128))
        ]),
        B.value ? (l(), n("div", re, [
          (l(!0), n(M, null, E(k.quotes, (o, t) => (l(), n("span", {
            key: t,
            class: D([{ "ds-quote-group__dot--active": t === a.value }, "ds-quote-group__dot"])
          }, null, 2))), 128))
        ])) : x("", !0)
      ])
    ], 34));
  }
}), fe = /* @__PURE__ */ Z(le, [["__scopeId", "data-v-8aabddea"]]);
export {
  fe as default
};
